module.exports = __webpack_public_path__ + "img/logo.b6f04243.svg";